/*
** Turning off react/display-name rule in this file
** as eslint treat this as a stateless component, which it's not.
** It's only meant to define validation rules for use across the app.
*/
/* eslint react/display-name: 0 */

import React from 'react';
import Validation from 'react-validation';
import { Alert } from 'react-bootstrap';

// Setting validation rules for login form validation
Object.assign(Validation.rules, {
    // Key name maps the rule
    required: {
        rule: value => (value.toString().trim().length !== 0),
        hint: () => (<Alert
          bsStyle="warning"
          style={{ marginTop: '5px' }}>
        This field is required.
      </Alert>),
    },
    validPassword: {
        rule: value => (!(value.length < 6 || value.length > 20)
        || !value.length),
        hint: () => (<Alert
          bsStyle="info"
          style={{ marginTop: '5px' }}>
          {'Password must have a : '}
          <strong>
            {'minimum length of 6 and a maximum length of 20.'}
          </strong>
      </Alert>),
    },
    validPasswordConfirmation: {
        rule: (value, components) => {
            const password = components.password.state;
            const passwordConfirm =
            components.confirmationPassword.state;
            const isBothUsed = password
                && passwordConfirm
                && password.isUsed
                && passwordConfirm.isUsed;
            const isBothChanged =
            isBothUsed && password.isChanged
            && passwordConfirm.isChanged;

            if (!isBothUsed || !isBothChanged) {
                return true;
            }

            return password.value === passwordConfirm.value;
        },
        hint: () => (<Alert
          bsStyle="info"
          style={{ marginTop: '5px' }}>
          {'Passwords must match'}
      </Alert>),
    },
    validUsername: {
        rule: value => {
            if (value.length > 64) {
                return false;
            }
            // String validation
            const validationRegEx = /^[a-zA-Z0-9=,.@\-_+]*$/;
            return value.match(validationRegEx);
        },
        hint: () => (<Alert
          bsStyle="info"
          style={{ marginTop: '5px' }}>
          {'Usernames can contain upper and lowercase'}
          <strong>{' alphanumeric characters with no spaces.'}</strong>
          <br />
           {'Usernames may also include any '}
           {'of the following characters:'}
           <strong>{'  =,.@-_+'}</strong>.
          <br />
          {'It must have a : '}
          <strong>
            {'minimum length of 1 and a maximum length of 64.'}
          </strong>
      </Alert>),
    },
    validEmail: {
        rule: value => {
            // Disabling eslint because of the regexp size.
            // This regexp makes sure the email complies with RFC 5322
            // eslint-disable-next-line
            const validationRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return value.match(validationRegEx);
        },
        hint: () => (<Alert
          bsStyle="info"
          style={{ marginTop: '5px' }}>
          <strong>
            {'Email is not valid.'}
          </strong>
      </Alert>),
    },
    validQuota: {
        rule: value => {
            if (!value.length) {
                return true;
            }
            const floatValue = parseFloat(value);
            return (!Number.isNaN(floatValue) && floatValue >= 0 &&
            floatValue.toString() === value.toString());
        },
        hint: () => (<Alert
          bsStyle="info"
          style={{ marginTop: '5px' }}>
          <strong>
            {'Quota must be a number of gibibytes (GiB).'}
          </strong>
      </Alert>),
    },
    validSetQuota: {
        rule: value => {
            if (!value.length) {
                return false;
            }
            const floatValue = parseFloat(value);
            return (!Number.isNaN(floatValue) && floatValue > 0 &&
            floatValue.toString() === value.toString());
        },
        hint: () => (<Alert
          bsStyle="info"
          style={{ marginTop: '5px' }}>
          <strong>
            {'Quota must be a positive number of gibibytes (GiB).'}
          </strong>
      </Alert>),
    },
    validCIDR: {
        rule: value => {
            if (!value.length) {
                return true;
            }
            const validationRegEx = /^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))?$/;
            return value.match(validationRegEx);
        },
        hint: () => (<Alert
          bsStyle="info"
          style={{ marginTop: '5px' }}>
          <strong>
            <i className="fa fa-info-circle"/>
            {' IP Address CIDR Notation is not valid.'}
          </strong>
      </Alert>),
    },
    validPolicyElement: {
        rule: value => {
            if (!value.length) {
                return true;
            }
            const validationRegEx = /^[a-zA-Z0-9=,.@\-_+]+$/;
            return value.match(validationRegEx);
        },
        hint: () => (<Alert
          bsStyle="warning"
          style={{ marginTop: '5px' }}>
          <strong>
            <i className="fa fa-info-circle"/>
            &nbsp;
            {'Can only contain alphanumeric characters. Policy names may' +
            ' also include any of the following characters:  =,.@-_+'}
          </strong>
      </Alert>),
    },
    validPolicyStatementElement: {
        rule: value => {
            if (!value.length) {
                return true;
            }
            const validationRegEx = /^[a-zA-Z0-9]+$/;
            return value.match(validationRegEx);
        },
        hint: () => (<Alert
          bsStyle="warning"
          style={{ marginTop: '5px' }}>
          <strong>
            <i className="fa fa-info-circle"/>
            &nbsp;
            {'Can only contain alphanumeric characters.'}
            </strong>
          </Alert>),
    },
});



/** WEBPACK FOOTER **
 ** ./src/utils/ValidationRules.js
 **/